export const PROMPT_STYLE_OPTIONS = [
  { value: 'simple', label: 'Simple (Short & Fast)' },
  { value: 'causal', label: 'Causal (Why & How)' },
  { value: 'vignette', label: 'Vignette (Scenario)' },
  { value: 'sherlock', label: 'Sherlock (Deduction)' },
  { value: 'common_bond', label: 'Common Bond (Pattern)' },
  { value: 'prediction', label: 'Prediction (System)' },
  { value: 'descriptive', label: 'Descriptive (Visual)' },
  { value: 'appositive', label: 'Appositive (Deductive Clues)' },
  { value: 'fast', label: 'Fast (Integrated Fun Facts)' },
] as const;

export type PromptStyle = (typeof PROMPT_STYLE_OPTIONS)[number]['value'];

export const DEFAULT_PROMPT_STYLE: PromptStyle = 'simple';
